import React, { useState, useEffect, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import { useParams, useHistory } from 'react-router-dom'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { trans } from '../../../../_providers/Translation'
import { buildSharedApiUrl, buildSharedApiData, addSharedParamsToFormData } from '../../../../_helpers/SharedParams'

//images
import loader from '../../../../assets/img/loader.svg'
import editImage from "@/assets/img/reservations/icons/edit.svg"
import deleteImage from "@/assets/img/reservations/icons/delete.svg"
import commentImage from "@/assets/img/reservations/icons/comment.svg"

//modals
import QuestionModal from '../../../modals/messages/Question'
import EditComment from './modals/EditComment'

function Comments(props) {
    const auth = useAuthDataContext()

    let params = useParams().id
    const history = useHistory()

    //refs
    const questionModalRef = useRef(null)
    const editCommentRef = useRef(null)

    const [comments, setComments] = useState({
        data: {
            fromCustomer: [],
            fromEmployees: []
        },
        loading: true,
    })

    useEffect(() => {
        // Build API URL with shared parameters
        const url = buildSharedApiUrl(`reservations/comments?id=${params}`, props.sharedParams)

        Api.get(url)
            .then(res => {

                let fromCustomer = res.data.filter(c => c.employee_id === null)
                let fromEmployees = res.data.filter(c => c.employee_id !== null)

                setComments(comments => ({
                    ...comments,
                    data: {
                        fromCustomer: fromCustomer,
                        fromEmployees: fromEmployees
                    },
                    loading: false,
                }))
            })
    }, [])

    const handleEdit = (comment) => {
        editCommentRef.current.open(comment)
    }

    const handleSend = e => {

        e.preventDefault()

        let url = 'reservations/comments/add'

        let formData = new FormData(e.target)

        formData.append('id', params)

        // Add shared parameters to FormData
        formData = addSharedParamsToFormData(formData, props.sharedParams)

        if (document.getElementById('comment').value == '') return

        Api.post(url, formData)
            .then(res => {
                setComments(prev => ({
                    ...prev,
                    data: {
                        ...prev.data,
                        fromEmployees: [res.data, ...prev.data.fromEmployees]
                    }
                }))

                // Preserve existing URL parameters while updating tab and indicator
                const currentParams = new URLSearchParams(window.location.search)
                currentParams.set('tab', 'comments')
                currentParams.set('indicator', new Date().getTime().toString())
                history.push(`?${currentParams.toString()}`)

            })

        document.getElementById('comment').value = ''

    }

    const handleUpdate = e => {
        e.preventDefault()

        let url = 'reservations/comments/edit'

        let formData = new FormData(e.target)

        // Add shared parameters to FormData
        formData = addSharedParamsToFormData(formData, props.sharedParams)

        Api.post(url, formData)
            .then(res => {
                let newData = comments.data.fromEmployees.map(c => {
                    if (Number(c.id) === Number(res.data.id)) {
                        c = res.data
                    }

                    return c
                })

                setComments(prev => ({
                    ...prev,
                    data: {
                        ...prev.data,
                        fromEmployees: newData
                    }
                }))
            })
    }

    const handleDelete = id => questionModalRef.current.open(id)

    const handleAcceptDelete = id => {
        const deleteData = buildSharedApiData({ id: id }, props.sharedParams)

        Api.post('reservations/comments/delete', deleteData).then(() => {
            let newData = comments.data.fromEmployees.filter(comment => {
                return comment.id !== id
            })

            setComments(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    fromEmployees: newData
                }
            }))

            // Preserve existing URL parameters while updating tab and indicator
            const currentParams = new URLSearchParams(window.location.search)
            currentParams.set('tab', 'comments')
            currentParams.set('indicator', new Date().getTime().toString())
            history.push(`?${currentParams.toString()}`)
        })
    }

    const createMarkup = html => {
        return {
            __html: String(html).replaceAll("\n", "<br/>")
        }
    }

    return (
        <div id="reservation-comments">
            {comments.loading ?
                <img src={loader} alt="loading" />
                :
                <div className="row comments">
                    <QuestionModal
                        mainMessage={trans('headings.question3')}
                        secondaryMessage={trans('subheadings.confirmDelete')}
                        ref={questionModalRef}
                        callback={handleAcceptDelete}
                    />
                    <EditComment
                        ref={editCommentRef}
                        handleUpdate={handleUpdate}
                    />
                    <div className="col">
                        <div className='pannel'>
                            <div className='head'>
                                {trans('random.fromClient')}
                            </div>
                            {comments.data.fromCustomer.length == 0 ?
                                <div className="panel-wrapper no-comments">
                                    <p>
                                        {trans('messages.noCommentsFromClient')}
                                    </p>
                                </div>
                                :
                                comments.data.fromCustomer.map(comment =>
                                    <div key={'c-' + comment.id} className="panel-wrapper">
                                        <h3>
                                            {comment.author && comment.author.name} {comment.author && comment.author.lastname}
                                        </h3>
                                        <time>
                                            {comment.created_dmy}
                                        </time>
                                        <p>
                                            {comment.comment}
                                        </p>
                                    </div>
                                )}
                        </div>

                    </div>
                    <div className="col">
                        <div className='pannel'>
                            <div className='head'>
                                {trans('random.fromEmployee')}
                            </div>
                            {props.data.can_modify &&
                                <form onSubmit={handleSend}>
                                    <textarea id="comment" name="comment" placeholder={trans('random.commentPlaceholder')}></textarea>
                                    <button className='button button-default'>
                                        <img src={commentImage} alt='Comment' />
                                        {trans('buttons.comment')}
                                    </button>
                                </form>
                            }
                            {comments.data.fromEmployees.length == 0 ?
                                <div className="pannel no-comments comment-holder">
                                    <p>
                                        {trans('messages.noCommentsFromEmployee')}
                                    </p>
                                </div>
                                :
                                comments.data.fromEmployees.map(comment =>
                                    <div key={'c-' + comment.id} className="pannel comment-holder">
                                        {comment.editable &&
                                            <div className="options">
                                                <span>
                                                    <img
                                                        src={editImage}
                                                        alt="edit"
                                                        onClick={() => handleEdit(comment)}
                                                    />
                                                </span>
                                                <span>
                                                    <img
                                                        src={deleteImage}
                                                        alt="delete"
                                                        onClick={() => handleDelete(comment.id)}
                                                    />
                                                </span>
                                            </div>}
                                        <h3>
                                            {comment.author && comment.author.name} {comment.author && comment.author.lastname}
                                        </h3>
                                        <time>
                                            {comment.created_dmy}
                                        </time>
                                        <p dangerouslySetInnerHTML={createMarkup(comment.comment)} />
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Comments